<template>
  <transition name="slide" :duration="duration">
    <div v-show="show" class="modal-container">
      <div class="modal">
        <div class="modal-dialog" :class="'modal-lg'">
          <div class="modal-content">
            <!--Header-->
            <div class="modal-header">
              <div class="modal-title">
                <div>Projected Data</div>
              </div>
            </div>
            <!--Container-->
            <div class="modal-body">
              <projectedData @dataupdated="update" :companyData="rawData" :selCompany="company" :isFromComp="isFrom"></projectedData>
            </div>
            <!--Footer-->
            <div class="modal-footer">
              <!-- <button type="button" class="mt-3" :class="'btn btn-primary'" @click="ok">Sumbit</button> -->
              <button
                type="button"
                class="mt-3"
                :class="'btn btn-secondary'"
                @click="cancel"
                data-dismiss="modal"
              >Cancel</button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop"></div>
    </div>
  </transition>
</template>
<script>
import VueJwtDecode from "vue-jwt-decode";
import http from "@/lib/http";
import projectedData from "@/views/manual-forms/projected-data";
export default {
  name: "projected-data-modal",
  components: {projectedData},
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary"
    },
    cancelClass: {
      type: String,
      default: "btn btn-secondary"
    },
    rawData: {
      type: Object
    },
    isFrom: {
      type: Number
    },
    company: {
      type: Object
    }
  },
  data() {
    return {
      show: false,
      duration: 200,
      pin: "",
      error: ""
    };
  },
  created() {
    if (this.show) {
      document.body.className += " modal-open";
      console.log("RawDAta", this.rawData);
    }
  },
  beforeDestroy() {
    document.body.className = document.body.className.replace(
      /\s?modal-open/,
      ""
    );
  },
  watch: {
    show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(() => {
          document.body.className = document.body.className.replace(
            /\s?modal-open/,
            ""
          );
        }, this.duration);
      }
    }
  },
  methods: {
    ok() {

    },
    cancel() {
      this.$emit("cancel");
      this.show = false;
    },
    clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open() {
      this.show = true;
    },
    update(obj){
      console.log("Model", obj);
      this.show = false;
      this.$emit("updateData", obj);
    }
  }
};
</script>
<style lang="scss">
span.error {
  color: #dc3545;
}
// For Transitioning
.slide-enter-active {
  animation: slide-in 3s fade forwards;
}
.slide-leave-active {
  animation: slide-out 3s fade forwards;
}

@keyframes slide-in {
  from {
    transform: translateY(250px);
  }
  to {
    transform: translateY(0);
  }
}
@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(250px);
  }
}

.modal {
  display: block;
}

.modal-dialog,
.modal-backdrop {
  transition: all 0.5s ease;
}

.modal-enter .modal-dialog,
.modal-leave-active .modal-dialog {
  opacity: 0;
  transform: translateY(-30%);
}

.modal-enter .modal-backdrop,
.modal-leave-active .modal-backdrop {
  opacity: 0;
}

.modal-backdrop {
  opacity: 0.5;
}

//Modal styles

.modal-header {
  height: 55px;
  padding: 0 1.6rem;
  border-bottom: 2px solid #eee;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
}

.modal-content {
  border-radius: 0;
}

.modal-footer {
  justify-content: center;
  padding: 0 2px;
  padding-bottom: 5px;
  flex-wrap: wrap;
  .btn {
    margin: 0 10px 20px 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/ProjectedDataFrm.vue